// Actions
export const SORT_PARTS = 'SORT_PARTS';
export const CHANGE_SORT_DIR = 'CHANGE_SORT_DIR';
export const SET_FILTERS = 'SET_FILTERS';

// UI
export const CHANGE_VIEW = 'CHANGE_VIEW';
export const STATUS_TEXT = "STATUS_TEXT";

// CRUD
export const GET_SERIES_PENDING = 'GET_SERIES_PENDING';
export const GET_SERIES_SUCCESS = 'GET_SERIES_SUCCESS';
export const GET_SERIES_FAILED = 'GET_SERIES_FAILED';
export const GET_SKILLS_PENDING = 'GET_SKILLS_PENDING';
export const GET_SKILLS_SUCCESS = 'GET_SKILLS_SUCCESS';
export const GET_SKILLS_FAILED = 'GET_SKILLS_FAILED';
export const ADD_PARTS_PENDING = 'ADD_PARTS_PENDING';
export const ADD_PARTS_SUCCESS = 'ADD_PARTS_SUCCESS';
export const ADD_PARTS_FAILED = 'ADD_PARTS_FAILED';
export const ADD_SKILL_PENDING = 'ADD_SKILL_PENDING';
export const ADD_SKILL_SUCCESS = 'ADD_SKILL_SUCCESS';
export const ADD_SKILL_FAILED = 'ADD_SKILL_FAILED';
export const GET_WORDTAGS_PENDING = 'GET_WORDTAGS_PENDING';
export const GET_WORDTAGS_SUCCESS = 'GET_WORDTAGS_SUCCESS';
export const GET_WORDTAGS_FAILED = 'GET_WORDTAGS_FAILED';
export const ADD_SKILL_STATUS_TEXT = 'ADD_SKILL_STATUS_TEXT';
export const REFRESH_SKILL_STATUS_TEXT = 'REFRESH_SKILL_STATUS_TEXT';
export const ADD_PART_STATUS_TEXT = 'ADD_PART_STATUS_TEXT';


// Middleware
export const SEARCH_PARTS_PENDING = 'SEARCH_PARTS_PENDING';
export const SEARCH_PARTS_SUCCESS = 'SEARCH_PARTS_SUCCESS';
export const SEARCH_PARTS_FAILED = 'SEARCH_PARTS_FAILED';

export const REQUEST_PARTS_PENDING = 'REQUEST_PARTS_PENDING';
export const REQUEST_PARTS_SUCCESS = 'REQUEST_PARTS_SUCCESS';
export const REQUEST_PARTS_FAILED = 'REQUEST_PARTS_FAILED';

export const GET_SKILL_INFO_PENDING = 'GET_SKILL_INFO_PENDING';
export const GET_SKILL_INFO_SUCCESS = 'GET_SKILL_INFO_SUCCESS';
export const GET_SKILL_INFO_FAILED = 'GET_SKILL_INFO_FAILED';